import { useState } from "react";
import { useField } from "formik";
import { TextField, LinearProgress, Typography, Box } from "@mui/material";
//import FormAlert from "../Alert/FormAlert";
import { useTheme } from "@mui/material";
import { useTranslation } from "../../language";

function getPasswordScore(password) {
  let score = 0;
  if (!password) return 0;
  if (password.length >= 8) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  return score;
}

const PasswordInput = ({ label, showStrength = true, ...props }) => {
  const [field, meta] = useField(props);
  const theme = useTheme();
  const { t } = useTranslation();
  const [showError, setShowError] = useState(true);
  const score = getPasswordScore(field.value);
  const progressValue = (score / 5) * 100;
  const strengthLabels = [
    t('pw_strength_too_weak'),
    t('pw_strength_weak'),
    t('pw_strength_fair'),
    t('pw_strength_good'),
    t('pw_strength_strong'),
    t('pw_strength_excellent'),
  ];
  const strengthLabel = strengthLabels[score];

  const getColor = () => {
    switch (score) {
      case 0:
      case 1:
        return "error";
      case 2:
        return "warning";
      case 3:
        return "info";
      case 4:
      case 5:
        return "success";
      default:
        return "inherit";
    }
  };

  return (
    <>
      <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        "& .MuiTextField-root": { mt: 2, width: "100%" },
      }}
    >
        <TextField
          variant="outlined"
          label={label}
          fullWidth
          size="small"
          margin="normal"
          {...field}
          {...props}
          error={Boolean(meta.touched && meta.error)}
          helperText={meta.touched && meta.error ? meta.error : ""}
          sx={{
           
            "& .MuiInputBase-input": {
              fontSize: '1rem',
              color: theme.palette.mode === 'dark'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
              fontWeight: 400,
            },
             // 🔹 LABEL COLOR (default + focus)
            "& .MuiInputLabel-root": {
              color: theme.palette.mode === 'dark' 
                ? theme.palette.grey[100] 
                : theme.palette.grey[900], 
              fontWeight:400,
              fontSize: '0.8rem'
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
            },

            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              backgroundColor: "transparent",
              transition: "border-color 0.2s ease, background-color 0.2s ease",
              "&:hover": {
                backgroundColor: theme.palette.mode === 'dark'
                  ? "rgba(255,255,255,0.03)"
                  : "rgba(0,0,0,0.015)",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.16)" : "rgba(0,0,0,0.14)",
                transition: "border-color 0.2s ease",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.28)" : "rgba(0,0,0,0.26)",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.main,
                borderWidth: 1.5,
              },
            },
              "& input": {
                backgroundColor: "transparent",
                "&:-webkit-autofill": {
                  WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
                },
              },

          }}
        />

        {showStrength && field.value && (
         <Box sx={{ mt: 1, width: "100%" }}>
            <LinearProgress
              variant="determinate"
              value={progressValue}
              color={getColor()}
              sx={{ height: 8, borderRadius: 5 }}
            />
            <Typography
              variant="caption"
              sx={{
                mt: 0.5,
                display: "block",
                color:
                  score <= 1
                    ? "error.main"
                    : score === 2
                    ? "warning.main"
                    : score === 3
                    ? "info.main"
                    : "success.main",
              }}
            >
              {strengthLabel}
            </Typography>
          </Box>
        )}
      </Box>

      
    </>
  );
};

export default PasswordInput;

/* removed
{meta.touched && meta.error && showError && (
        <FormAlert
          severity="warning"
          message={meta.error}
          onClose={() => setShowError(false)}
        />
      )}
*/